<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="8" md="12">
          <b-card no-body class="card-profile bg-secondary mt-5">
            <b-row class="justify-content-center">
              <b-col lg="8" class="border-lg-2">
                <div class="card-profile-image" style="border: 0">
                  <b-img src="/img/logo.png" style="border: 0" />
                </div>
              </b-col>
            </b-row>
            <b-card-body class="pt-7 px-5">
              <div class="text-center mb-4">
                <h3>About Us</h3>
                <p class="lead pb-5">
                  We're a tight-knit group of engineers that wants to accomplish one, simple thing -
                  <mark>help you stop worrying about downtime.</mark>
                </p>
                <b-row class="align-items-center">
                  <b-col md="3" sm="12">
                    <p style="font-weight: 600">
                      We give you peace of mind.
                    </p>
                  </b-col>
                  <b-col md="9" sm="12">
                    <p>
                      We notify you, immediately, when issues occur with your websites, APIs, or
                      third party dependencies.
                    </p>
                  </b-col>
                </b-row>
                <b-row class="align-items-center">
                  <b-col md="3" sm="12">
                    <p style="font-weight: 600">
                      We keep your customers informed.
                    </p>
                  </b-col>
                  <b-col md="9" sm="12">
                    <p>
                      Through beautiful, responsive, status pages, your customers will always stay
                      in the loop.
                    </p>
                  </b-col>
                </b-row>
                <b-row class="align-items-center">
                  <b-col md="3" sm="12">
                    <p style="font-weight: 600">
                      We monitor your performance.
                    </p>
                  </b-col>
                  <b-col md="9" sm="12">
                    <p>
                      Response time is a key metric in customer happiness.
                    </p>
                  </b-col>
                </b-row>
                <p class="lead align-items-center">
                  And we do so by consistently providing
                  <mark>world-class support.</mark>
                </p>
                <p class="text-muted">
                  Don't believe us? Reach out at hello@boltscale.io and see how we can help.
                </p>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "lock",
  data() {
    return {
      model: {
        password: ""
      }
    };
  }
};
</script>
<style></style>
